import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  items: [],
  status: null,
};

export const bannerFetching = createAsyncThunk(
  "banner/bannerFetching",
  async () => {
    const res = await axios.get(`${process.env.REACT_APP_URL}/api-banners`);
    return res.data;
  }
);

export const bannerSlice = createSlice({
  name: "banner",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(bannerFetching.pending, (state) => {
      state.status = "loading..";
    });
    builder.addCase(bannerFetching.fulfilled, (state, action) => {
      state.status = "";
      state.items = action.payload;
    });
    builder.addCase(bannerFetching.rejected, (state) => {
      state.status = "Something Went Wrong";
    });
  },
});

export default bannerSlice.reducer;
